import { RequestDetailsForApproval } from "@api";
import { CardWrapper } from "@components";
import {
  Grid,
  makeStyles,
  IconButton,
  Theme,
  Typography,
} from "@material-ui/core";
import React, { useState } from "react";
import { RequestsDetailTable } from "./requestsDetailsTable";
import { TextareaAutosize } from "@material-ui/core";
import { Form } from "@components";
import { Field } from "@components/form/fields/field";
import { Save as SaveIcon } from "@material-ui/icons";
import { updateRfNumber } from "@api";
import { alertService } from "@services";
const useStyles = makeStyles((theme: Theme) => ({
  underlined: {
    textDecoration: "underline",
  },
  rightBox: {
    borderBottom: "1px solid #cecece",
    borderLeft: "1px solid #cecece",
    padding: theme.spacing(3),
  },
  leftBox: {
    borderBottom: "1px solid #cecece",
    padding: theme.spacing(3),
  },
  bottomBox: {
    padding: theme.spacing(3),
  },
}));

interface Props {
  request: RequestDetailsForApproval;
}

export const RequestDetails: React.FC<Props> = ({ request }) => {
  const classes = useStyles();

  const [rfNo, setRfNo] = useState(request?.serviceTicketNumber || "");

  const saveRfNo = (e: any) => {
    if (rfNo) {
      updateRfNumber(rfNo, request.id)
        .then((response) => {
          // if response is true
          if (response) {
            alertService.success({
              msg: "RF No. has been saved.",
            });
          } else {
            alertService.danger({
              msg: "RF No. has failed to saved.",
            });
          }
        })
        .catch((error) => {
          console.log(error);
          if (error.response) {
            alertService.danger({
              msg: "RF No. has failed to saved.",
              statusCode: error.response.status,
            });
          }
        });
    }
  };

  const rfTextBox = (
    <Form>
      <Field label="" size={10}>
        <TextareaAutosize
          onChange={(e) => setRfNo(e.target.value)}
          rowsMin={1}
          placeholder="Enter RF. # here."
          value={rfNo || ""}
        />
      </Field>
      <Field label="" size={2}>
        <IconButton
          size="small"
          disabled={!rfNo}
          onClick={saveRfNo}
          title="Save RF. #"
        >
          <SaveIcon fontSize="small" />
        </IconButton>
      </Field>
    </Form>
  );

  const revokeTypeValue = request?.revokeType
    ? ` - ${request.revokeType}`
    : null;
  return (
    <CardWrapper title="Request Details">
      <Grid container>
        <Grid item container xs={6} className={classes.leftBox}>
          <Grid container item spacing={2}>
            <Grid item xs={12}>
              <Typography variant="body1" className={classes.underlined}>
                Basic Information
              </Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography variant="body2">
                <span>
                  <b>Type of Action:</b>
                </span>{" "}
                {request?.requestType}
                {revokeTypeValue}
              </Typography>
              <Typography variant="body2">
                <span>
                  <b>Effective Date of this Action:</b>
                </span>{" "}
                {request?.effectiveDate}
              </Typography>
              <Typography variant="body2">
                <span>
                  <b>Date Requested:</b>
                </span>{" "}
                {request?.dateAdded}
              </Typography>
              <Typography variant="body2">
                <span>
                  <b>System Category:</b>
                </span>{" "}
                {request?.category}
              </Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography variant="body2">
                <span>
                  <b>Reference No:</b>
                </span>{" "}
                {request?.referenceNumber}
              </Typography>
              <Typography variant="body2">
                <span>
                  <b>Advanced Request:</b>
                </span>{" "}
                {request?.isAdvance ? "Yes" : "No"}
              </Typography>
              <Typography variant="body2">
                <span>
                  <b>Start Date:</b>
                </span>{" "}
                {request?.advanceDate}
              </Typography>
              <Typography variant="body2">
                <span>
                  <b>RF No.:</b>
                </span>{" "}
                {rfTextBox}
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography variant="body2">
                <span>
                  <b>Justification:</b>
                </span>{" "}
                {request?.justification}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
        <Grid
          item
          container
          xs={6}
          className={classes.rightBox}
          alignItems="flex-start"
        >
          <Grid container item spacing={2}>
            <Grid item xs={12}>
              <Typography variant="body1" className={classes.underlined}>
                User Information
              </Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography variant="body2">
                <span>
                  <b>Name:</b>
                </span>{" "}
                {request?.userName}
              </Typography>
              <Typography variant="body2">
                <span>
                  <b>Email:</b>
                </span>{" "}
                {request?.userEmail}
              </Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography variant="body2">
                <span>
                  <b>Employee ID:</b>
                </span>{" "}
                {request?.userID}
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography variant="body2">
                <span>
                  <b>Note:</b>
                </span>{" "}
                {""}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
        <Grid container item xs={12} className={classes.bottomBox}>
          <Grid item xs={12}>
            <Typography variant="body1">System Access Required</Typography>
          </Grid>
          <Grid item xs={12}>
            <RequestsDetailTable
              user={request.userName}
              accessRequests={request.accessRequests}
              status={request.status}
            ></RequestsDetailTable>
          </Grid>
        </Grid>
      </Grid>
    </CardWrapper>
  );
};
